export const BOOKING_PREFIX = '@@booking';

export const GET_BOOKING_LIST = BOOKING_PREFIX + '/booking_list';
export const GET_BOOKING_LIST_FULFILLED = BOOKING_PREFIX + '/booking_list_fulfilled';
export const GET_BOOKING_LIST_CANCELLED = BOOKING_PREFIX + '/booking_list_cancelled';
export const GET_BOOKING_LIST_REJECTED = BOOKING_PREFIX + '/booking_list_rejected';

export const GET_AVAILABLE_TIMESLOTS = BOOKING_PREFIX + '/get_available_timeslots';
export const GET_AVAILABLE_TIMESLOTS_FULFILLED = BOOKING_PREFIX + '/get_available_timeslots_fulfilled';
export const GET_AVAILABLE_TIMESLOTS_CANCELLED = BOOKING_PREFIX + '/get_available_timeslots_cancelled';
export const GET_AVAILABLE_TIMESLOTS_REJECTED = BOOKING_PREFIX + '/get_available_timeslots_rejected';

export const GET_TIMESLOT_GROUP = BOOKING_PREFIX + '/get_timeslot_group';
export const GET_TIMESLOT_GROUP_FULFILLED = BOOKING_PREFIX + '/get_timeslot_group_fulfilled';
export const GET_TIMESLOT_GROUP_CANCELLED = BOOKING_PREFIX + '/get_timeslot_group_cancelled';
export const GET_TIMESLOT_GROUP_REJECTED = BOOKING_PREFIX + '/get_timeslot_group_rejected';

export const SUBMIT_BOOKING = BOOKING_PREFIX + '/submit_booking';
export const SUBMIT_BOOKING_FULFILLED = BOOKING_PREFIX + '/submit_booking_fulfilled';
export const SUBMIT_BOOKING_CANCELLED = BOOKING_PREFIX + '/submit_booking_cancelled';
export const SUBMIT_BOOKING_REJECTED = BOOKING_PREFIX + '/submit_booking_rejected';

export const GET_RECORD_LIST = BOOKING_PREFIX + '/get_record_list';
export const GET_RECORD_LIST_FULFILLED = BOOKING_PREFIX + '/get_record_list_fulfilled';
export const GET_RECORD_LIST_CANCELLED = BOOKING_PREFIX + '/get_record_list_cancelled';
export const GET_RECORD_LIST_REJECTED = BOOKING_PREFIX + '/get_record_list_rejected';

export const GET_RECORD_DETAIL = BOOKING_PREFIX + '/get_record_detail';
export const GET_RECORD_DETAIL_FULFILLED = BOOKING_PREFIX + '/get_record_detail_fulfilled';
export const GET_RECORD_DETAIL_CANCELLED = BOOKING_PREFIX + '/get_record_detail_cancelled';
export const GET_RECORD_DETAIL_REJECTED = BOOKING_PREFIX + '/get_record_detail_rejected';

export const SELECT_BOOKING_ITEM = BOOKING_PREFIX + '/select_booking_item';
export const DESELECT_BOOKING_ITEM = BOOKING_PREFIX + '/deselect_booking_item';
export const UPDATE_BOOKING_FORM = BOOKING_PREFIX + '/update_booking_form';
export const UPDATE_AVAILABLE_PEOPLE = BOOKING_PREFIX + '/update_available_people';
export const FIX_BOOKING_FORM = BOOKING_PREFIX + '/fix_booking_form';
export const SET_TIMESLOT_PRESELECT = BOOKING_PREFIX + '/set_timeslot_preselect';

export const NOT_AVAILABLE_DATE = BOOKING_PREFIX + '/NOT_AVAILABLE_DATE';

export const RESET_BOOKING = BOOKING_PREFIX + '/reset_booking';

export const SubmitState = {
    init: 'init',
    filling: 'filling',
    loading: 'loading',
    success: 'success',
    failed: 'failed',
}

export const RecordState = {
    all: 'all',
    pending: 'pending',
    success: 'success',
    fail: 'fail',
    checkedIn: 'checked_in',
}

export const QuestionType = {
    text: 'text',
    select: 'select',
    checkbox: 'checkbox',
    radio: 'radio',
}

export const FieldNames = {
    location: 'branch',
    date: 'date',
    timeslot: 'timeslot',
    numberOfPeople: 'people',
    name: 'name',
    phone: 'phone',
    question: 'question',
    remark: 'remarks',
    memberId: 'memberId',
    productId: 'productId',
}